(() => {
  if (window.__libertyJourneyReady) return;
  window.__libertyJourneyReady = true;
  const preparePopupGuard = () => {
    if (window.__libertyPopupGuardReady || !document.querySelector('[data-lc-quiet-signup]') || !document.body) return;
    window.__libertyPopupGuardReady = true;
    const formSelector = 'form[data-testid="klaviyo-form-YhJWfc"]';
    const dialogSelector = `[role="dialog"]:has(${formSelector})`;
    const lastCloseAt = new WeakMap();
    let scheduled = false;
    const closeSignupOffer = () => {
      if (!document.querySelector('[data-lc-quiet-signup]')) return;
      document.querySelectorAll(dialogSelector).forEach(dialog => {
        const button = dialog.querySelector('button[aria-label="Close dialog"]');
        if (!button || button.disabled || Date.now() - (lastCloseAt.get(button) || 0) < 750) return;
        lastCloseAt.set(button, Date.now());
        button.click();
      });
    };
    const scheduleClose = () => {
      if (scheduled) return;
      scheduled = true;
      queueMicrotask(() => { scheduled = false; closeSignupOffer(); });
    };
    const belongsToSignupOffer = node => node.nodeType === 1 && (node.matches(formSelector) || node.matches(dialogSelector) || node.closest(dialogSelector));
    const observer = new MutationObserver(records => {
      if (records.some(record => record.type === 'attributes' ? belongsToSignupOffer(record.target) : [...record.addedNodes].some(node => belongsToSignupOffer(node) || node.nodeType === 1 && node.querySelector(formSelector)))) scheduleClose();
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'] });
    closeSignupOffer();
  };
  preparePopupGuard();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', preparePopupGuard, { once: true });
  document.addEventListener('shopify:section:load', preparePopupGuard);
  if (window.Shopify?.designMode) return;
  const events = Object.freeze({
    journey_selected: ['welcome_kit', 'custom', 'premade'],
    kit_form_started: ['welcome_kit'],
    kit_request_submitted: ['welcome_kit'],
    custom_order_started: ['custom'],
    custom_artwork_selected: ['custom'],
    custom_cart_added: ['custom'],
    premade_order_started: ['premade'],
    premade_cart_added: ['premade']
  });
  const oncePerPage = new Set(['kit_form_started', 'kit_request_submitted', 'custom_order_started', 'custom_artwork_selected', 'premade_order_started']);
  const delivered = new Set();
  const allowed = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; }
    catch { return false; }
  };
  const publish = (event, journey) => {
    if (!events[event]?.includes(journey) || !allowed()) return;
    const key = `${event}:${journey}`;
    if (oncePerPage.has(event) && delivered.has(key)) return;
    const payload = { journey, step: event, schema_version: 1 };
    let sent = false;
    if (typeof window.Shopify?.analytics?.publish === 'function') {
      try {
        const result = window.Shopify.analytics.publish(`liberty:${event}`, payload);
        if (result && typeof result.catch === 'function') result.catch(() => {});
        sent = true;
      } catch {}
    }
    if (typeof window.clarity === 'function') {
      try { window.clarity('event', `liberty_${event}`); sent = true; } catch {}
    }
    if (sent) delivered.add(key);
  };
  const preparePrivacy = () => {
    if (window.Shopify?.customerPrivacy || typeof window.Shopify?.loadFeatures !== 'function') return;
    try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => {}); } catch {}
  };
  preparePrivacy();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', preparePrivacy, { once: true });
  window.addEventListener('load', preparePrivacy, { once: true });
  document.addEventListener('visitorConsentCollected', preparePrivacy);
  document.addEventListener('lc:journey', event => {
    const name = event.detail?.event;
    const journey = event.detail?.journey;
    if (!['custom_artwork_selected', 'custom_cart_added', 'premade_cart_added'].includes(name)) return;
    publish(name, journey);
  });
  const started = event => {
    if (!event.isTrusted || !event.target?.closest) return;
    if (event.target.closest('[data-lc-custom-order] form')) publish('custom_order_started', 'custom');
    else if (event.target.closest('[data-catalog-form]')) publish('premade_order_started', 'premade');
  };
  document.addEventListener('input', started, { capture: true, passive: true });
  document.addEventListener('change', started, { capture: true, passive: true });
  document.addEventListener('pointerdown', started, { capture: true, passive: true });
  document.addEventListener('click', event => {
    if (!event.isTrusted || !event.target?.closest) return;
    const link = event.target.closest('a[href]');
    if (!link) return;
    let journey = link.dataset.lcJourney;
    if (!['welcome_kit', 'custom', 'premade'].includes(journey)) {
      let url;
      try { url = new URL(link.href, window.location.origin); } catch { return; }
      if (url.origin !== window.location.origin) return;
      const path = url.pathname.replace(/\/$/, '');
      if (path === '/pages/welcome-kit') journey = 'welcome_kit';
      else if (path === '/products/50-custom-pvc-patches') journey = 'custom';
      else if (path === '/collections/ready-to-press-pvc-patches') journey = 'premade';
      else return;
    }
    publish('journey_selected', journey);
  }, { capture: true, passive: true });
  window.addEventListener('message', event => {
    if (event.origin !== 'https://formbuilder.hulkapps.com') return;
    const message = event.data;
    if (!message || typeof message !== 'object' || message.source !== 'liberty-welcome-kit') return;
    if (!['kit_form_started', 'kit_request_submitted'].includes(message.type)) return;
    const frame = [...document.querySelectorAll('[data-lc-kit-hulk] iframe')].find(candidate => candidate.contentWindow === event.source);
    if (!frame) return;
    publish(message.type, 'welcome_kit');
  });
})();
